import * as React from 'react';
import { scienceBlue } from '../abstracts/colours';

export interface IconProps {
  fill?: string;
}

const CancelOutlined: React.SFC<IconProps> = ({ fill = scienceBlue }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <rect width="23" height="23" x=".5" y=".5" stroke={fill} rx="2" />
      <path d="M0 0L24 0 24 24 0 24z" />
      <path
        fill={fill}
        fillRule="nonzero"
        d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
      />
    </g>
  </svg>
);

export default CancelOutlined;
